import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=a528967a&scoped=true&"
import script from "./ReportForm.vue?vue&type=script&lang=js&"
export * from "./ReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a528967a",
  null
  
)

export default component.exports